import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { motion, useReducedMotion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './Benefits.css';

// "How it works" — replaces the old benefits cards.
// The key benefits (1-to-1, expert instructors, flexible schedule, projects) live inside the steps.
const steps = [
  {
    title: 'Free trial class',
    text: 'Your child meets a computer science instructor live, 1-to-1, and builds something small in the first session.',
    tags: ['Free', 'Live 1-to-1'],
  },
  {
    title: 'A path made for them',
    text: 'We recommend the right course for their age and experience, with days and times that fit around school.',
    tags: ['Flexible schedule', 'Change teacher anytime'],
  },
  {
    title: 'Build, show, level up',
    text: 'Every session ends with a project to save and show. You get progress reports, and a certificate at the end.',
    tags: ['Real projects', 'Certificate'],
  },
];

const Benefits = () => {
  const reduceMotion = useReducedMotion();

  const reveal = (delay = 0) =>
    reduceMotion
      ? {}
      : {
          initial: { opacity: 0, y: 20 },
          whileInView: { opacity: 1, y: 0 },
          transition: { duration: 0.5, delay },
          viewport: { once: true, margin: '-60px' },
        };

  return (
    <section className="rmb" aria-labelledby="rmb-title">
      <div className="rmb-inner">
        <motion.header className="rmb-header" {...reveal(0)}>
          <span className="rmb-eyebrow">How it works</span>
          <h2 id="rmb-title" className="rmb-title">
            From first class to <span>first creation</span>
          </h2>
        </motion.header>

        <ol className="rmb-steps">
          {steps.map((s, i) => (
            <motion.li key={s.title} className="rmb-step" {...reveal(0.08 * (i + 1))}>
              <span className={`rmb-num rmb-num--${i + 1}`} aria-hidden="true">
                {i + 1}
              </span>
              <div className="rmb-copy">
                <h3 className="rmb-step-title">{s.title}</h3>
                <p className="rmb-step-text">{s.text}</p>
                <div className="rmb-tags">
                  {s.tags.map((t) => (
                    <span key={t} className="rmb-tag">
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            </motion.li>
          ))}
        </ol>

        <motion.div className="rmb-cta" {...reveal(0.3)}>
          <Link to="/FreeTrial" className="rmb-btn">
            Start with a free class
            <FontAwesomeIcon icon={faArrowRight} />
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default Benefits;